export const CONFIG = {
  jaeren: {
    dividendFactor: 0.0031,
    minimumPayment: 100,
    year: 2025,
    disclaimerText: `Utbyttesummen refererer til foreløpig overskuddsdisponering. Formelt
            vedtak fattes av generalforsamlingen 26. mars. Kalkulatoren beregner ut
            fra at du har vært kunde hele året. Nedre utbetalingsgrense er 100
            kroner. Dersom du har hatt mindre enn 32 422 kroner i lån og/eller
            innskudd, vil du for 2025 ikke kvalifisere til minimumsutbetalingen på
            100 kroner.`,
  },
  sandnes: {
    dividendFactor: 0.003367,
    minimumPayment: 0,
    year: 2025,
    disclaimerText: `Kalkulatoren beregner ut fra at du har vært kunde hele året. Har du ikke vært kunde i hele 2025,
            får du likevel kundeutbytte, men kalkulatoren vil da ikke gi deg riktig beløp.`,
    style: {
      "--color-font-secondary": "#555",
      "--color-input-font": "#222",
      "--color-input-background": "#ffd600",
      "--color-slider-background": "#ffd600",
      "--color-slider-thumb": "#222",
      "--color-radio-background": "#ffd600",
      "--color-radio-dot": "#222",
    },
  },
  rogalandbm: {
    dividendFactor: 0.00335,
    minimumPayment: 0,
    year: 2024,
    isCorporateBanking: true,
    heading: "Regn ut hva din bedrift får i kundeutbytte",
    disclaimerText: `Kalkulatoren beregner ut fra at dere har vært bedriftskunde hele året. Har du ikke vært
            bedriftskunde i hele 2024, får du likevel kundeutbytte, men kalkulatoren vil da ikke gi deg riktig beløp.`,
    style: {
      "--color-font-secondary": "#555",
      "--color-input-font": "#222",
      "--color-input-background": "#ffd600",
      "--color-slider-background": "#ffd600",
      "--color-slider-thumb": "#222",
      "--color-radio-background": "#ffd600",
      "--color-radio-dot": "#222",
    },
  },
  narvik: {
    dividendFactor: 0.003,
    minimumPayment: 100,
    year: 2026,
    disclaimerText: `Utbyttesummen refererer til foreløpig overskuddsdisponering. Formelt
            vedtak fattes av bankens generalforsamling i mars og utbetales i april 2027.
            Kalkulatoren beregner ut fra at du har vært kunde hele året. Nedre utbetalingsgrense
            er 100 kroner. Dersom du har hatt mindre enn 30 000 kroner i lån og/eller innskudd,
            vil du i 2026 ikke kvalifisere til minimumsutbetalingen på 100 kroner.`,
    style: {
      "--color-font-secondary": "#555",
      "--color-input-font": "#fff",
      "--color-input-background": "#0065A4",
      "--color-slider-background": "#55BCE7",
      "--color-slider-thumb": "#0065A4",
      "--color-radio-background": "#55BCE7",
      "--color-radio-dot": "#0065A4",
    },
  },
  oslofjord: {
    dividendFactor: 0.0035,
    minimumPayment: 100,
    year: 2025,
    heading: "Se hva du kan få i kundeutbytte",
    introText: `Utbyttekalkulatoren gir deg en pekepinn på hva du kan få i kundeutbytte.
            Kundeutbytte er basert på hva du hadde av innskudd og lån forrige år.`,
    disclaimerText: `Kundeutbyttet ditt blir beregnet ut fra hvor mye lån og innskudd du
            hadde i løpet av 2025. For å få minste utbetaling på 100 kroner i 2026, må du
            ha hatt minst 28 572 kroner i lån og/eller innskudd i 2025. Kalkulatoren forutsetter
            at beløpene har stått hele året. Det faktiske utbyttet ditt justeres dersom lån eller
            innskudd har endret seg i løpet av perioden. Fond og aksjer teller ikke med.`,
    style: {
      "--color-font-secondary": "#555",
      "--color-input-background": "#1B4650",
      "--color-slider-thumb": "#1B4650",
      "--color-radio-dot": "#1B4650",
    },
  },
};
